import React from 'react';
import UserProfileCard from './components/UserProfileCard';

const App = () => {
  return (
    <div className="App">
      <UserProfileCard />
    </div>
  );
};

export default App;
